module.exports = __webpack_public_path__ + "img/planting.1113227a.jpg";